export enum MaritalStatus {
	CASADO = 'CASADO',
	DIVORCIADO = 'DIVORCIADO',
	SEPARADO = 'SEPARADO',
	SOLTEIRO = 'SOLTEIRO',
	UNIAO_ESTAVEL = 'UNIAO_ESTAVEL',
	VIUVO = 'VIUVO',
}
